import React, { useCallback, useMemo, useState } from 'react'
import { CookieContext } from './'
import { CookieBannerVisibility } from 'src/Libs/cookie-banner/types'

interface Props {
  showCookieBanner: CookieBannerVisibility
  children?: React.ReactNode
}

/**
 * Provider for the cookie banner, so only one banner is shown
 * @param showCookieBanner - initial value if the banner should be displayed
 */
const Provider: React.VFC<Props> = ({ showCookieBanner, children }) => {
  const [displayCookieBanner, setDisplayCookieBanner] = useState<CookieBannerVisibility>(showCookieBanner)
  const [isOnProfilePage, setIsOnProfilePage] = useState(false)

  const toggleIsOnProfilePage = useCallback((value: boolean) => {
    setIsOnProfilePage(value)
  }, [])

  const toggleDisplayCookieBanner = useCallback((value: CookieBannerVisibility) => {
    setDisplayCookieBanner(value)
  }, [])

  const value = useMemo(
    () => ({
      displayCookieBanner,
      setDisplayCookieBanner: toggleDisplayCookieBanner,
      isOnProfilePage,
      setIsOnProfilePage: toggleIsOnProfilePage,
    }),
    [displayCookieBanner, isOnProfilePage, toggleDisplayCookieBanner, toggleIsOnProfilePage]
  )

  return <CookieContext.Provider value={value}>{children}</CookieContext.Provider>
}

export default Provider
